document.addEventListener("DOMContentLoaded", function () {
  let url = new URL(window.location.href);
  let baseUrl = `${url.protocol}//${url.host}`;
  let currentVariant = "";

  const buckleForm = document.querySelector("#belt_buckle_variation");
  if (buckleForm) {
    redirectUrl(buckleForm, baseUrl, currentVariant);
  }

  const selectButton = document.getElementById("selected-product-button");
  const popup = document.querySelector(".popup");

  // ▼ アイコン操作（スコープ外でも使えるようにする）
  function toggleDropdownIcon(isOpen) {
    const dropdownIcon = document.querySelector("#selected-product-button svg");
    if (!dropdownIcon) return;

    dropdownIcon.style.transform = isOpen ? "rotate(270deg)" : "rotate(90deg)";
  }

  if (selectButton && popup) {
    selectButton.addEventListener("click", function (event) {
      event.stopPropagation();
      popup.classList.toggle("show");
      toggleDropdownIcon(popup.classList.contains("show"));
    });
  }

  // ▼ 外クリックで閉じる
  document.addEventListener("click", function () {
    if (popup && popup.classList.contains("show")) {
      popup.classList.remove("show");
      toggleDropdownIcon(false);
    }
  });
});

// ▼ リダイレクト処理
const redirectUrl = (buckleElement, baseurl, currentVariant) => {
  if (!buckleElement) return;

  const buttons = buckleElement.querySelectorAll("a.option");

  buttons.forEach((button) => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();

      let variant_id = "";
      let productUrl = "";

      // ▼ 現在のバリアント取得
      if (
        document.querySelector(".variant-option__swatch-value") &&
        document.querySelector(".dropdown_box button span")
      ) {
        currentVariant =
          document
            .querySelector(".variant-option__swatch-value")
            .textContent.trim() +
          " / " +
          document
            .querySelector(".dropdown_box button span")
            .textContent.trim();
      }

      // ▼ URL安全に生成（?variant除去）
      let handle = button.getAttribute("data-url").split("?")[0];
      let url = `${baseurl}${handle}.js`;

      try {
        const productObject = await getProductJsonBuckle(url);
        const variants = productObject.variants;

        // ▼ variant一致チェック（ゆるめ）
        variants.forEach((element) => {
          if (element.title.trim() === currentVariant) {
            variant_id = element.id;
          }
        });

        if (variant_id) {
          productUrl = `${baseurl}${handle}?variant=${variant_id}`;
        } else {
          productUrl = `${baseurl}${handle}`;
        }

        window.location.replace(productUrl);
      } catch (error) {
        console.error("リダイレクト処理でエラー:", error);
      }
    });
  });
};

const getProductJsonBuckle = async (url) => {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error("HTTP error");

    return await response.json();
  } catch (error) {
    console.error(error);
    throw new Error("Failed to get product JSON.");
  }
};
